export const C_YES_AND_NOT = {
  YES: {
    name: "Si",
    label: "Si",
    value: "yes",
    id: 1
  },
  NOT: {
    name: "No",
    label: "No",
    value: "not",
    id: 0
  }
};

export const O_YES_AND_NOT = {
  [C_YES_AND_NOT.YES.id]: C_YES_AND_NOT.YES,
  [C_YES_AND_NOT.NOT.id]: C_YES_AND_NOT.NOT,
  [C_YES_AND_NOT.YES.value]: C_YES_AND_NOT.YES,
  [C_YES_AND_NOT.NOT.value]: C_YES_AND_NOT.NOT
};
export const A_YES_AND_NOT = [C_YES_AND_NOT.NOT, C_YES_AND_NOT.YES];
